__turbopack_context__.v({
  "className": "cormorant_garamond_702e805b-module__DW4pLG__className",
});
